import { Box } from '@mui/material';
import JobPostApplyActionButtons from './JobPostApplyActionButtons';
import JobPostApplyEmployerInfo from './JobPostApplyEmployerInfo';
import { ICompanyUser } from '../../../interfaces/jobpost.interface';

export interface IJobPostApplySidebarProps {
  companyUser: ICompanyUser;
}

const JobPostApplySidebar: React.FC<IJobPostApplySidebarProps> = ({
  companyUser,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap="22px">
      <Box
        sx={{
          minWidth: 227,
          width: { xs: '100%', lg: 314 },
          borderRadius: '1px',
          bgcolor: 'background.white',
        }}
      >
        <JobPostApplyActionButtons />
        <JobPostApplyEmployerInfo companyUser={companyUser} />
      </Box>
    </Box>
  );
};

export default JobPostApplySidebar;
